<template>
    <!-- main-wrap h-full bg-page -->
    <main class="main-wrap main-height bg-page">
        <el-scrollbar>
            <div class="p-4">
                <router-view v-if="isRouteShow" v-slot="{ Component, route }">
                    <keep-alive :include="includeList" :max="20">
                        <component :is="Component" :key="route.fullPath" />
                    </keep-alive>
                </router-view>
            </div>
        </el-scrollbar>
    </main>
</template>

<script setup lang="ts">
import useAppStore from '@/stores/modules/app'
import useTabsStore from '@/stores/modules/multipleTabs'
import useSettingStore from '@/stores/modules/setting'

const appStore = useAppStore()
const tabsStore = useTabsStore()
const settingStore = useSettingStore()
const isRouteShow = computed(() => appStore.isRouteShow)
const showFooter = computed(() => appStore.showFooter)
const includeList = computed(() =>
    settingStore.openMultipleTabs ? tabsStore.getCacheTabList : []
)
</script>

<style>
.main-height {
    height: v-bind("showFooter ? 'calc(100% - 50px)' : '100%'");
}
</style>
